export default __webpack_public_path__ + "static/media/Moon-Only.1477bd5a.png";